import React from 'react';
import i18next from 'i18next';
import { List, Item, Value, Label } from './wrapper';
import { VisualHeading } from '../Heading';
import { Price, OldPrice } from '../Price';
import { numberSeparator } from '../../utils/formats';
import { getMarketCode } from '../../utils/market';

interface PriceTableProps {
  price: number;
  leasingPrice?: number;
  priceExclVat?: number;
  discount?: number;
}

const PriceTable = ({ price, discount, leasingPrice, priceExclVat }: PriceTableProps) => {
  const marketCode = getMarketCode();

  return (
    <List>
      <Item>
        <Label>
          <VisualHeading>{i18next.t('other.price')}</VisualHeading>
        </Label>
        <Value>
          <Price>
            {numberSeparator(price)} {i18next.t('currency.default')}
          </Price>
        </Value>
      </Item>
      {discount !== undefined && (
        <Item $reducedSpacing>
          <Label />
          <Value>
            <OldPrice>
              {numberSeparator(price + discount)} {i18next.t('currency.default')}
            </OldPrice>
          </Value>
        </Item>
      )}
      {leasingPrice && (
        <Item>
          <Label>
            <VisualHeading>{i18next.t('other.privateLeasingPrice')}</VisualHeading>
          </Label>
          <Value>
            <Price>
              {numberSeparator(leasingPrice)} {i18next.t('currency.default')}
            </Price>
          </Value>
        </Item>
      )}
      {priceExclVat && marketCode !== 'NO' && (
        <Item>
          <Label>
            <VisualHeading>{i18next.t('other.priceExclVat')}</VisualHeading>
          </Label>
          <Value>
            <Price>
              {numberSeparator(priceExclVat)} {i18next.t('currency.default')}
            </Price>
          </Value>
        </Item>
      )}
    </List>
  );
};

export default PriceTable;
